import { render } from "./App.vue?vue&type=template&id=9c4ebefc"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=9c4ebefc&lang=css"

import exportComponent from "/Users/Learning/Resource/workspace/vscode/HTML/jiang/anniversary/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__